// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"j0-z"};